import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

export default function ShareRedirectHandler({ AiAgentComponent }) {
  const location = useLocation();
  const { aiStrategyId } = useParams();
  const searchParams = new URLSearchParams(location.search);

  const hasShareToken = searchParams.has('share');
  const isPublicShare = searchParams.get('public') === 'true';
  const isShareUrl = hasShareToken || isPublicShare;

  if (isShareUrl && aiStrategyId) {
    return <Navigate to={`/share/${aiStrategyId}${location.search}`} replace />;
  }

  return (
    <ProtectedRoute requirePayment={true}>
      {AiAgentComponent ? <AiAgentComponent /> : null}
    </ProtectedRoute>
  );
}
